import {
  ControllerRenderProps,
  IconVariant,
  Select,
  SelectChangeEvent,
} from '@otp/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { WttpQuestionResponseStatus } from 'src/graphql/generated/graphql';

type StatusProps = {
  field: ControllerRenderProps<any, 'status'>;
  hasError: boolean;
  onChange: (value: SelectChangeEvent<string>) => void;
  issuesCount?: number;
  className?: string;
  disabled?: boolean;
};

export const StatusField = ({
  field,
  hasError,
  onChange,
  issuesCount = 0,
  className,
  disabled,
}: StatusProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'wttp.question-response.status',
  });

  const statusOptions = useMemo(
    () => [
      { value: WttpQuestionResponseStatus.Okay, name: t('okay') },
      {
        value: WttpQuestionResponseStatus.Issue,
        name: t('issue'),
        extra: issuesCount === 0 && t('opens-new-issue'),
        iconVariant: IconVariant.AddIcon,
      },
      {
        value: WttpQuestionResponseStatus.Fixed,
        name: t('fixed'),
        extra: t('note-required'),
        iconVariant: IconVariant.AddIcon,
      },
      { value: WttpQuestionResponseStatus.Skipped, name: t('skipped') },
    ],
    [t, issuesCount],
  );

  const currentStatusValue = field.value;

  return (
    <Select
      key={currentStatusValue}
      onChange={onChange}
      fullWidth={true}
      className={className}
      options={statusOptions}
      placeholder={t('not-answered')}
      defaultValue={currentStatusValue}
      error={hasError}
      disabled={disabled}
      value={undefined}
      inputRef={field.ref}
    />
  );
};
